module.exports = __webpack_public_path__ + "img/materio-banner.e04ade87.png";